import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./i18n/config";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Mission from "./pages/Mission";
import Breeders from "./pages/Breeders";
import BankInfo from "./pages/BankInfo";
import Standard from "./pages/Standard";
import Articles from "./pages/Articles";
import Events from "./pages/Events";
import Organizations from "./pages/Organizations";
import Contact from "./pages/Contact";
import PortalLanding from "./pages/portal/PortalLanding";
import Login from "./pages/portal/Login";
import Register from "./pages/portal/Register";
import Profile from "./pages/portal/Profile";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Admin routes (no header/footer) */}
          <Route path="/yonetim" element={<AdminLogin />} />
          <Route path="/yonetim/dashboard" element={<AdminDashboard />} />
          
          {/* Public routes (with header/footer) */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/mission" element={<Mission />} />
                  <Route path="/breeders" element={<Breeders />} />
                  <Route path="/bank-info" element={<BankInfo />} />
                  <Route path="/standard" element={<Standard />} />
                  <Route path="/articles" element={<Articles />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/organizations" element={<Organizations />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/portal" element={<PortalLanding />} />
                  <Route path="/portal/login" element={<Login />} />
                  <Route path="/portal/register" element={<Register />} />
                  <Route path="/portal/profile" element={<Profile />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
